import { render } from "./RichTextField.vue?vue&type=template&id=3ed9b588"
import script from "./RichTextField.vue?vue&type=script&lang=js"
export * from "./RichTextField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__